/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './pagina-nao-encontrada/pagina-nao-encontrada.component.ngfactory';
import * as i4 from './app.component.ngfactory';
import * as i5 from '@angular/common';
import * as i6 from '@angular/platform-browser';
import * as i7 from '@angular/animations/browser';
import * as i8 from '@angular/platform-browser/animations';
import * as i9 from '@angular/animations';
import * as i10 from '@angular/forms';
import * as i11 from '@angular/http';
import * as i12 from '../../app/utils/custom-browser-xhr.service/custom-browser-xhr.service';
import * as i13 from '../../app/utils/http-client/httpClientFactory';
import * as i14 from '@angular/router';
import * as i15 from 'ngx-cookie/src/cookie-options-provider';
import * as i16 from 'angular-sortablejs/dist/src/sortablejs.service';
import * as i17 from 'ngx-cookie/src/cookie.service';
import * as i18 from '../../app/utils/modal/modal.service';
import * as i19 from '../../app/app-services/local-storage.service';
import * as i20 from '../../app/app-services/tenant.service';
import * as i21 from '../../app/app-services/autenticacao.service';
import * as i22 from '../../app/utils/feedback/feedback.service';
import * as i23 from '../../app/app-guards/autenticacao.guard';
import * as i24 from '../../app/app-services/grupo.service';
import * as i25 from '../../app/app-services/usuario.service';
import * as i26 from '../../app/app-services/notificacao.service';
import * as i27 from '../../app/app-guards/tenant.resolver';
import * as i28 from '../../app/app-services/plano.service';
import * as i29 from '../../app/app-services/teleconsulta-especialidades.service';
import * as i30 from '../../app/app-services/restricao-teleconsulta.service';
import * as i31 from '../../app/app-services/restricao-agendamento-presencial.service';
import * as i32 from '../../app/app-services/status-exibicao-autorizacao.service';
import * as i33 from '../../app/app-services/qualificacao.service';
import * as i34 from '../../app/pagina-nao-encontrada/pagina-nao-encontrada.component';
import * as i35 from '../../app/app-routing.module';
import * as i36 from 'ngx-cookie/index';
import * as i37 from 'angular-sortablejs/dist/src/sortablejs.module';
import * as i38 from 'ng2-charts/charts/charts';
import * as i39 from '../../app/utils/modal/modal.module';
import * as i40 from 'angular-sortablejs/dist/src/globals';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.PaginaNaoEncontradaComponentNgFactory,i4.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i5.NgLocalization,i5.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i6.DomSanitizer,i6.ɵe,[i5.DOCUMENT]),i0.ɵmpd(6144,
          i0.Sanitizer,(null as any),[i6.DomSanitizer]),i0.ɵmpd(4608,i6.HAMMER_GESTURE_CONFIG,
          i6.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i6.EVENT_MANAGER_PLUGINS,
          (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i6.ɵDomEventsPlugin(p0_0),new i6.ɵKeyEventsPlugin(p1_0),new i6.ɵHammerGesturesPlugin(p2_0,
                p2_1)];
          },[i5.DOCUMENT,i5.DOCUMENT,i5.DOCUMENT,i6.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
          i6.EventManager,i6.EventManager,[i6.EVENT_MANAGER_PLUGINS,i0.NgZone]),i0.ɵmpd(135680,
          i6.ɵDomSharedStylesHost,i6.ɵDomSharedStylesHost,[i5.DOCUMENT]),i0.ɵmpd(4608,
          i6.ɵDomRendererFactory2,i6.ɵDomRendererFactory2,[i6.EventManager,i6.ɵDomSharedStylesHost]),
          i0.ɵmpd(5120,i7.AnimationDriver,i8.ɵc,([] as any[])),i0.ɵmpd(5120,i7.ɵAnimationStyleNormalizer,
              i8.ɵd,([] as any[])),i0.ɵmpd(4608,i7.ɵAnimationEngine,i8.ɵb,[i7.AnimationDriver,
              i7.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i8.ɵe,
              [i6.ɵDomRendererFactory2,i7.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i6.ɵSharedStylesHost,(null as any),[i6.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i6.Meta,i6.Meta,
              [i5.DOCUMENT]),i0.ɵmpd(4608,i6.Title,i6.Title,[i5.DOCUMENT]),i0.ɵmpd(4608,
              i9.AnimationBuilder,i8.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i6.DOCUMENT]),i0.ɵmpd(4608,i10.ɵi,i10.ɵi,([] as any[])),i0.ɵmpd(4608,
              i11.BrowserXhr,i12.CustomBrowserXhr,([] as any[])),i0.ɵmpd(4608,i11.ResponseOptions,
              i11.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i11.XSRFStrategy,
              i11.ɵb,([] as any[])),i0.ɵmpd(4608,i11.XHRBackend,i11.XHRBackend,[i11.BrowserXhr,
              i11.ResponseOptions,i11.XSRFStrategy]),i0.ɵmpd(4608,i11.RequestOptions,
              i11.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i11.Http,i13.httpClientFactory,
              [i11.XHRBackend,i11.RequestOptions]),i0.ɵmpd(5120,i14.ActivatedRoute,
              i14.ɵf,[i14.Router]),i0.ɵmpd(4608,i14.NoPreloading,i14.NoPreloading,
              ([] as any[])),i0.ɵmpd(6144,i14.PreloadingStrategy,(null as any),[i14.NoPreloading]),
          i0.ɵmpd(135680,i14.RouterPreloader,i14.RouterPreloader,[i14.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i14.PreloadingStrategy]),i0.ɵmpd(4608,i14.PreloadAllModules,
              i14.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i14.ROUTER_INITIALIZER,
              i14.ɵi,[i14.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i14.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i15.CookieOptionsProvider,i15.CookieOptionsProvider,
              [i15.COOKIE_OPTIONS,i0.Injector]),i0.ɵmpd(4608,i16.SortablejsService,
              i16.SortablejsService,([] as any[])),i0.ɵmpd(4608,i17.CookieService,
              i17.CookieService,[i15.CookieOptionsProvider]),i0.ɵmpd(4608,i18.ModalService,
              i18.ModalService,([] as any[])),i0.ɵmpd(4608,i19.LocalStorageService,
              i19.LocalStorageService,([] as any[])),i0.ɵmpd(4608,i20.TenantService,
              i20.TenantService,[i19.LocalStorageService,i17.CookieService,i11.Http]),
          i0.ɵmpd(4608,i21.AutenticacaoService,i21.AutenticacaoService,[i19.LocalStorageService,
              i11.Http,i14.Router,i20.TenantService,i17.CookieService]),i0.ɵmpd(4608,
              i22.FeedbackService,i22.FeedbackService,([] as any[])),i0.ɵmpd(4608,
              i23.AutenticacaoGuard,i23.AutenticacaoGuard,[i21.AutenticacaoService,
                  i14.Router,i22.FeedbackService]),i0.ɵmpd(4608,i24.GrupoService,i24.GrupoService,
              [i11.Http,i21.AutenticacaoService,i19.LocalStorageService]),i0.ɵmpd(4608,
              i25.UsuarioService,i25.UsuarioService,[i11.Http,i21.AutenticacaoService,
                  i19.LocalStorageService]),i0.ɵmpd(4608,i26.NotificacaoService,i26.NotificacaoService,
              [i11.Http,i21.AutenticacaoService,i19.LocalStorageService]),i0.ɵmpd(4608,
              i27.TenantResolveGuard,i27.TenantResolveGuard,[i20.TenantService,i14.Router]),
          i0.ɵmpd(4608,i28.PlanoService,i28.PlanoService,[i11.Http]),i0.ɵmpd(4608,
              i29.TeleconsultaEspecialidadeService,i29.TeleconsultaEspecialidadeService,
              [i11.Http]),i0.ɵmpd(4608,i30.RestricaoTeleconsultaService,i30.RestricaoTeleconsultaService,
              [i11.Http]),i0.ɵmpd(4608,i31.RestricaoAgendamentoPresencialService,i31.RestricaoAgendamentoPresencialService,
              [i11.Http]),i0.ɵmpd(4608,i32.StatusExibicaoAutorizacaoService,i32.StatusExibicaoAutorizacaoService,
              [i11.Http]),i0.ɵmpd(4608,i33.QualificacaoGuiaMedicoCnuService,i33.QualificacaoGuiaMedicoCnuService,
              [i11.Http]),i0.ɵmpd(512,i5.CommonModule,i5.CommonModule,([] as any[])),
          i0.ɵmpd(1024,i0.ErrorHandler,i6.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,
              () => {
                return [i14.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i14.ɵg,i14.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i6.ɵc(p0_0,p0_1),i14.ɵh(p1_0)];
              },[[2,i6.NgProbeToken],[2,i0.NgProbeToken],i14.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i6.BrowserModule,i6.BrowserModule,[[3,i6.BrowserModule]]),i0.ɵmpd(512,
              i8.BrowserAnimationsModule,i8.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i10.ɵba,i10.ɵba,([] as any[])),i0.ɵmpd(512,i10.FormsModule,i10.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i11.HttpModule,i11.HttpModule,([] as any[])),
          i0.ɵmpd(1024,i14.ɵa,i14.ɵd,[[3,i14.Router]]),i0.ɵmpd(512,i14.UrlSerializer,
              i14.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,i14.ChildrenOutletContexts,
              i14.ChildrenOutletContexts,([] as any[])),i0.ɵmpd(256,i14.ROUTER_CONFIGURATION,
              {},([] as any[])),i0.ɵmpd(1024,i5.LocationStrategy,i14.ɵc,[i5.PlatformLocation,
              [2,i5.APP_BASE_HREF],i14.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i5.Location,
              i5.Location,[i5.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i14.ROUTES,
              () => {
                return [[{path:'404',component:i34.PaginaNaoEncontradaComponent},{path:'login',
                    loadChildren:'app/autenticacao/autenticacao.module#AutenticacaoModule'},
                    {path:':tenantCodigo/login',loadChildren:'app/autenticacao/autenticacao.module#AutenticacaoModule'},
                    {path:':tenantCodigo/excluir-conta',loadChildren:'app/excluir-conta/autenticacao.module#AutenticacaoModule'},
                    {path:'',loadChildren:'app/inicio/inicio.module#InicioModule',
                        canActivate:[i23.AutenticacaoGuard]},{path:'midia',loadChildren:'app/midia/midia.module#MidiaModule',
                        canActivate:[i23.AutenticacaoGuard]},{path:':tenantCodigo',
                        loadChildren:'app/inicio/inicio.module#InicioModule',canActivate:[i23.AutenticacaoGuard],
                        resolve:{tenant:i27.TenantResolveGuard}},{path:'**',redirectTo:'/404'}]];
              },([] as any[])),i0.ɵmpd(1024,i14.Router,i14.ɵe,[i0.ApplicationRef,i14.UrlSerializer,
              i14.ChildrenOutletContexts,i5.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i14.ROUTES,i14.ROUTER_CONFIGURATION,[2,i14.UrlHandlingStrategy],
              [2,i14.RouteReuseStrategy]]),i0.ɵmpd(512,i14.RouterModule,i14.RouterModule,
              [[2,i14.ɵa],[2,i14.Router]]),i0.ɵmpd(512,i35.AppRoutingModule,i35.AppRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i36.CookieModule,i36.CookieModule,([] as any[])),
          i0.ɵmpd(512,i37.SortablejsModule,i37.SortablejsModule,([] as any[])),i0.ɵmpd(512,
              i38.ChartsModule,i38.ChartsModule,([] as any[])),i0.ɵmpd(512,i39.ModalModule,
              i39.ModalModule,([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,
              ([] as any[])),i0.ɵmpd(256,i15.COOKIE_OPTIONS,{},([] as any[])),i0.ɵmpd(256,
              i40.GLOBALS,{animation:150},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTWFyY2Vsb01hcnRpbnNGZXJyZWkvRGVza3RvcC9VbmlvMi9VbmlvQ21zL1VuaW9DbXMvQXBwL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9NYXJjZWxvTWFydGluc0ZlcnJlaS9EZXNrdG9wL1VuaW8yL1VuaW9DbXMvVW5pb0Ntcy9BcHAvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts